import PropTypes from 'prop-types'
import React from 'react'
import Image from './images'
import { StaticImage } from "gatsby-plugin-image"

const Header = ({timeout, menuBar, menuBarClick}) => {
  return(
    <header id="header" style={timeout ? { display: 'none' } : {}}>
      <div onClick={()=>{menuBarClick()}} className={`menu-btn ${menuBar ? 'close' : ''}`} >
        <div className="btn-line"></div>
        <div className="btn-line"></div>
        <div className="btn-line"></div>
      </div>
      <Image imageName="leonil-logo.png" className="logo" alt="logo"/>
    </header>
  );
}

Header.propTypes = {
  timeout: PropTypes.bool,
  menuBarClick: PropTypes.func,
  menuBar: PropTypes.bool
}

export default Header
